module.exports = __webpack_public_path__ + "img/Hardware.a9335810.png";